import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Redirect, Switch } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';

import HomePage from './containers/HomePage';
import AdminBranchView from './containers/AdminBranchView';
import { useAuth0 } from './react-auth0-spa';

function App() {
  const { loading } = useAuth0();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <CssBaseline />

      <Switch>
        <PrivateRoute path="/home" component={HomePage} />
        <PrivateRoute
          path="/admin-view/branch/:branchId"
          component={AdminBranchView}
        />

        <Redirect from="/" to="/home" />
      </Switch>
    </React.Fragment>
  );
}

export default App;
